import { api } from './api';
import type { Drug, DrugSearchResult, InteractionWarning } from '@dpfs/shared';

export interface SearchDrugsParams {
  q: string;
  limit?: number;
  controlledOnly?: boolean;
}

export interface CheckInteractionsResponse {
  warnings: InteractionWarning[];
}

export interface GenericAlternative {
  id: string;
  tradeName: string;
  dci: string;
  manufacturer: string;
  dosageForm: string;
  strength: string;
  referencePrice?: number;
  priceDifference?: number;
}

export interface GenericAlternativesResponse {
  originalDrug: {
    id: string;
    tradeName: string;
    dci: string;
    referencePrice?: number;
  };
  alternatives: GenericAlternative[];
}

export const drugsService = {
  async search(params: SearchDrugsParams): Promise<{ drugs: DrugSearchResult[] }> {
    const response = await api.get('/drugs/search', { params });
    return response.data;
  },

  async getById(id: string): Promise<Drug> {
    const response = await api.get(`/drugs/${id}`);
    return response.data;
  },

  async checkInteractions(drugIds: string[]): Promise<CheckInteractionsResponse> {
    const response = await api.post('/drugs/check-interactions', { drugIds });
    return response.data;
  },

  async getNotice(id: string): Promise<{ noticeContent: string | null; noticeUrl: string | null; tradeName: string }> {
    const response = await api.get(`/drugs/${id}/notice`);
    return response.data;
  },

  async getGenericAlternatives(drugId: string): Promise<GenericAlternativesResponse> {
    const response = await api.get(`/drugs/${drugId}/generics`);
    return response.data;
  },
};
